import { Injectable } from "@angular/core";

import { CoreState } from "../state";

@Injectable({
	providedIn: "root",
})
export class GameSessionSelector {
	getActiveGameSessionId() {
		return (state: CoreState): string | undefined => state.gameSession.activeGameSessionId;
	}
}
